import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import FontAwesome icons
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import { Link } from 'react-router-dom';

const Footer = () => {
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="container-fluid footer py-3" style={{ backgroundColor: '#000' }}>
      <div className="container">
        <div className="row d-flex justify-content-between align-items-center">
          {/* Logo and Description */}
          <div className="col-lg-6 col-md-6 mb-4">
            <div className="footer-item">
              <h1 className="text-primary font-weight-bold  text-white mb-3" style={{ fontSize: "1.5rem" }}>
                <Link
                  to="/"
                  className="navbar-brand"
                  onClick={handleScrollToTop} // Scrolls to the top when clicked
                >
                  <img
                    src="logo_1-01.png"
                    alt="Everest Momo Cafe Logo"
                    className="img-fluid"
                    style={{ height: "60px", transition: "height 0.3s ease"  }}
                  />
                  Everest Momo Cafe
                </Link>
              </h1>
              <p className="lh-lg mb-2 text-white" style={{ fontSize: '0.85rem' }}>
                Providing exceptional catering and service to make your events memorable. From delicious food to professional service, we’re here to help you celebrate!
              </p>
            </div>
          </div>

          {/* Contact Us and Social Icons */}
          <div className="col-lg-6 col-md-6 text-lg-end text-md-end">
            <div className="footer-item">
              <h4 className="mb-2 text-primary" style={{ fontSize: '1.5rem' }}>Contact Us</h4>
              <div className="d-flex flex-column align-items-lg-end align-items-md-end">
                <p className="text-white mb-1">
                  <i className="fa fa-map-marker-alt text-primary me-2"></i> Street Address: Eerikinkatu 29
                </p>
                <p className="text-white mb-1">
                  <i className="fa fa-map-marker-alt text-primary me-2"></i> Postal Code: 20100
                </p>
                <p className="text-white mb-1">
                  <i className="fa fa-map-marker-alt text-primary me-2"></i> City: Turku
                </p>
                <p className="text-white mb-1">
                  <i className="fa fa-phone-alt text-primary me-2"></i> (+358) 041 740 6648
                </p>
                {/* Social Icons */}
                <div className="footer-icon d-flex justify-content-end">
                  <a
                    href="https://facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white me-3"
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Facebook_f_logo_%282019%29.svg/1200px-Facebook_f_logo_%282019%29.svg.png"
                      alt="Facebook"
                      style={{ width: '20px', height: '20px' }}
                    />
                  </a>
                  <a
                    href="https://instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white"
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Instagram_logo_2022.svg/1200px-Instagram_logo_2022.svg.png"
                      alt="Instagram"
                      style={{ width: '20px', height: '20px' }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
